import { Fragment } from 'react'

import { type ListingFragment } from '@/generated'
import { InlineAdSlot } from '@/lib/ads/ad-slots/srp/InlineAdSlot'
import { type Listing } from '@/types/search'

import { ZipRecruiterListingCard } from '../listing-card/ZipRecruiterListingCard'

type RenderZipRecruiterListingProps = {
  item: Listing
  index: number
  listings: ListingFragment[]
  handleTrackListingClick: () => void
}

export const RenderZipRecruiterListing = ({
  handleTrackListingClick,
  index,
  item,
  listings,
}: RenderZipRecruiterListingProps) => {
  const key = `zip-listing-${item.id}-${index}`

  return (
    <Fragment key={key}>
      <li data-testid={`listing-card-list-item-${index}`}>
        <ZipRecruiterListingCard
          description={item.description}
          id={item.id}
          location={item.location?.name}
          seoUrl={item.seoUrl}
          title={item.title}
          handleTrackListingClick={handleTrackListingClick}
        />
      </li>

      <InlineAdSlot index={index} totalListings={listings.length} />
    </Fragment>
  )
}
